import React from 'react';
import ScheduleReportView from './ScheduleReportView';

// V3 reskin: page renders its own glass hero, so the legacy Breadcrumbs
// strip + Bootstrap Container wrapper are dropped.
const ScheduleReport = () => <ScheduleReportView />;

export default ScheduleReport;
